'use client';

import { formatPrice, type FormatPriceOptions } from '@template-project/afrodita-components';
import {
  discountDisplayCents,
  discountDisplayLabel,
  type Discount,
} from '@template-project/storefront-bff-client';
import {
  DiscountBreakdownLabel,
  DiscountBreakdownRow,
  DiscountBreakdownValue,
} from './CartSummaryV2.styled';

interface DiscountBreakdownListProps {
  discounts: Discount[];
  priceOptions: FormatPriceOptions;
}

export function DiscountBreakdownList({
  discounts,
  priceOptions,
}: Readonly<DiscountBreakdownListProps>) {
  const visibleRows = discounts.filter(
    (row) => discountDisplayCents(row) > 0 || (row.percent ?? 0) > 0,
  );

  if (visibleRows.length === 0) {
    return null;
  }

  return (
    <>
      {visibleRows.map((row, index) => {
        const amountCents = discountDisplayCents(row);
        const label = discountDisplayLabel(row);
        const suffix =
          amountCents <= 0 && row.percent
            ? ` (${row.percent}% off)`
            : '';

        return (
          <DiscountBreakdownRow key={`${row.source}-${label}-${index}`}>
            <DiscountBreakdownLabel variant="caption" as="span">
              {`${label}${suffix}`}
            </DiscountBreakdownLabel>
            {amountCents > 0 ? (
              <DiscountBreakdownValue variant="caption" weight="semibold" as="span">
                -{formatPrice(amountCents, priceOptions)}
              </DiscountBreakdownValue>
            ) : (
              <DiscountBreakdownValue variant="caption" weight="semibold" as="span">
                —
              </DiscountBreakdownValue>
            )}
          </DiscountBreakdownRow>
        );
      })}
    </>
  );
}
